import Vue from 'vue';
import MaintenanceLogs from '@/plugins/graphql/queries/v2/app-maintenance-logs.gql';
import { MaintenanceModel } from '@/helpers/entities/models/MaintenanceLogModel';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import { omitBy, isNull } from 'lodash';
/**
 * Component for fetching App Maintenance Logs
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.1.13}
 */
export default Vue.extend({
    mixins: [PaginatorMixin],
    apollo: {
        maintenanceLogs: {
            query: MaintenanceLogs,
            variables() {
                const vars = {
                    after: this.startCursor,
                    appUuid: this.appUuid,
                    first: this.perPage,
                };
                return omitBy(vars, isNull);
            },
            update(data) {
                const logs = data.appMaintenanceLogs.edges;
                const logNode = (log) => {
                    return new MaintenanceModel(log.node);
                };
                return logs.map(logNode);
            },
            result({ data }) {
                const self = this;
                const query = data.appMaintenanceLogs;
                self.totalCount = query.totalCount;
                self.pageInfo = query.pageInfo;
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            maintenanceLogs: null,
        };
    },
    render() {
        if (this.$scopedSlots.default) {
            const self = this;
            return this.$scopedSlots.default({
                maintenanceLogs: self.maintenanceLogs,
                totalCount: self.totalCount,
                pageInfo: self.pageInfo,
                fetchRecordsFrom: self.fetchRecordsFrom,
            });
        }
    },
});
